import { useEffect } from 'react';

import useAlert from "#hooks/useAlert";
import { useAppSelector } from "#redux/store";

function AlertReader() {
  const alert = useAlert();

  const notification = useAppSelector((state) => state.notification);

  useEffect(
    () => {
      if (!notification || !notification.show) {
        return;
      }

      if (notification.title) {
        alert.show(
          <>
            <div>
              {notification.title}
            </div>
            <div>
              {notification.msg}
            </div>
          </>,
          { variant: notification.kind },
        )
      } else if (typeof notification.msg === 'string') {
        alert.show(
          notification.msg,
          { variant: notification.kind },
        )
      } else {
        alert.show(
          <div>
            {notification.msg}
          </div>,
          { variant: notification.kind },
        )
      }
    },
    [alert, notification],
  );

  return null;
}

export default AlertReader;
